import { render, staticRenderFns } from "./ChunkProcess.vue?vue&type=template&id=48d3915c&"
import script from "./ChunkProcess.vue?vue&type=script&lang=js&"
export * from "./ChunkProcess.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports